<div container>
  <ui-error [state]="loadState"></ui-error>

  <form [formGroup]="form" *visible="loadState.isCompleted" autocomplete="off">
    <div class="table-responsive mat-elevation-z2" *ngIf="!appLayout.isMobile">
      <table mat-table [dataSource]="dataSource" formArrayName="diplomas" [ui-column-width]="[250, 100, 100, 72]">
        <ng-container matColumnDef="courseName">
          <th mat-header-cell *matHeaderCellDef i18n>שם קורס</th>

          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <mat-form-field floatLabel="never" *ngIf="row.value">
              <input
                type="text"
                matInput
                autocomplete="off"
                [placeholder]="courseNamePlaceholder.text"
                formControlName="courseName"
              />
            </mat-form-field>
          </td>

          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="credits">
          <th mat-header-cell *matHeaderCellDef i18n>נקודות זכות</th>

          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <mat-form-field floatLabel="never" *ngIf="row.value">
              <input
                type="number"
                matInput
                i18n-placeholder
                placeholder="נקודות זכות"
                formControlName="credits"
                autocomplete="off"
              />
            </mat-form-field>
          </td>

          <td mat-footer-cell *matFooterCellDef i18n>סה"כ: {{ creditsCount }}</td>
        </ng-container>

        <ng-container matColumnDef="grade">
          <th mat-header-cell *matHeaderCellDef i18n>ציון</th>

          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <mat-form-field floatLabel="never">
              <input
                type="number"
                matInput
                i18n-placeholder
                placeholder="ציון"
                formControlName="grade"
                autocomplete="off"
              />
            </mat-form-field>
          </td>

          <td mat-footer-cell *matFooterCellDef i18n>ממוצע: {{ average | number: '1.0-2' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>

          <td mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
            <button
              mat-icon-button
              type="button"
              [matTooltip]="deleteButtonTooltip.text"
              (click)="removeDiplomaCourse(index)"
              [disabled]="!canRemoveDiplomaCourse(row)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>

          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
    </div>

    <div *ngIf="appLayout.isMobile" formArrayName="diplomas">
      <ng-template #rowEditor let-row let-i="index">
        <registration-entry-editor-shell
          [formGroupName]="i"
          [mode]="rowsEditor.isAddingRow(row) ? 'add' : 'edit'"
          [addTitle]="addTitle.text"
          [editTitle]="editTitle.text"
          [invalid]="rowsEditor.invalid"
          [invalidBody]="invalidBody.text"
          [cancelTooltip]="cancelTooltip.text"
          (cancel)="rowsEditor.cancel(row)"
          (save)="rowsEditor.save(row)"
        >
          <mat-form-field appearance="fill">
            <mat-label i18n>שם קורס</mat-label>
            <input type="text" matInput formControlName="courseName" autocomplete="off" required />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>נקודות זכות</mat-label>
            <input type="number" matInput formControlName="credits" autocomplete="off" required />
            <mat-error *ngIf="row | hasError: 'credits'" i18n>שדה חובה</mat-error>
            <mat-error *ngIf="row | hasError: 'credits' : 'min'" i18n
              >מספר נקודות הזכות קטן מידי, נא הזן מספר גדול מ-0</mat-error
            >
            <mat-error *ngIf="row | hasError: 'credits' : 'max'" i18n>מספר נקודות הזכות שהזנת גדול מדי</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label i18n>ציון</mat-label>
            <input type="number" matInput formControlName="grade" autocomplete="off" required />
            <mat-error *ngIf="row | hasError: 'grade'" i18n>שדה חובה</mat-error>
            <mat-error *ngIf="row | hasError: 'grade' : 'min'" i18n
              >הציון שהזנת אינו תקין, נא הזן ציון גדול או 0</mat-error
            >
            <mat-error *ngIf="row | hasError: 'grade' : 'max'" i18n>נא הזן ציון נמוך או שווה 100</mat-error>
          </mat-form-field>
        </registration-entry-editor-shell>
      </ng-template>

      <ng-template #rowCard let-row let-i="index">
        <registration-entry-card
          [title]="row.value.courseName"
          [editTooltip]="editTooltip.text"
          [deleteTooltip]="deleteTooltip.text"
          [canDelete]="canRemoveDiplomaCourse(row)"
          (edit)="rowsEditor.startEdit(row)"
          (delete)="removeDiplomaCourse(i)"
        >
          <div footerStart *ngIf="row.value.credits" class="registration-entry-card__meta">
            <span i18n>נקודות זכות</span>&nbsp;{{ row.value.credits }}
          </div>
          <span footerBadge class="registration-entry-card__badge" *ngIf="row.value.grade != null">
            <span i18n>ציון</span>&nbsp;{{ row.value.grade }}
          </span>
        </registration-entry-card>
      </ng-template>

      <registration-entry-list
        [rows]="rows"
        [editor]="rowsEditor"
        [addLabel]="addTitle.text"
        [editorTemplate]="rowEditor"
        [cardTemplate]="rowCard"
      >
      </registration-entry-list>
    </div>

    <ui-alert type="warning" *visible="showError && errorList.length > 0">
      <div ui-header i18n>לא ניתן לשמור מכיון שאחד או יותר מהפרטים שגויים או חסרים</div>

      <ul ui-body>
        <ng-container *ngFor="let error of errorList">
          <li *ngIf="error == 'credits-required'" i18n>חובה להזין מספר נקודות זכות</li>
          <li *ngIf="error == 'credits-min'" i18n>מספר נקודות הזכות קטן מידי, נא הזן מספר גדול מ-0</li>
          <li *ngIf="error == 'credits-max'" i18n>מספר נקודות הזכות שהזנת גדול מדי</li>
          <li *ngIf="error == 'grade-required'" i18n>חובה להזין ציון</li>
          <li *ngIf="error == 'grade-min'" i18n>הציון שהזנת אינו תקין, נא הזן ציון גדול או 0</li>
          <li *ngIf="error == 'grade-max'" i18n>נא הזן ציון נמוך או שווה 100</li>
        </ng-container>
      </ul>
    </ui-alert>

    <ui-error [state]="saveState"></ui-error>

    <ui-progress-button color="primary" [state]="saveState" (progress)="saveAsync()" i18n>
      שמור והמשך
    </ui-progress-button>
  </form>
</div>

<term #courseNamePlaceholder i18n>
  {gender, select, male {הזן} female {הזיני}}
  שם קורס
</term>

<term #deleteButtonTooltip i18n>
  {gender, select, male {מחק} female {מחקי}}
  שורה
</term>

<term #deleteTooltip i18n>
  {gender, select, male {מחק} female {מחקי}}
  שורה
</term>

<term #editTooltip i18n>
  {gender, select, male {ערוך} female {ערכי}}
</term>

<term #cancelTooltip i18n>ביטול</term>

<term #addTitle i18n>הוספת קורס</term>

<term #editTitle i18n>עריכת קורס</term>

<term #invalidBody i18n>חובה להזין שם קורס, נקודות זכות וציון</term>
